import React, { PureComponent } from 'react'
import {connect} from "react-redux";

import * as actions from "../../store/actions/actions";
import Header from "../../components/Headers/Header";
import {Button, Card, CardBody, CardHeader, Container, FormGroup, Input, Row} from "reactstrap";
import Col from "react-bootstrap/Col";
import { FormControl } from "react-bootstrap";
import * as Roles from "../../store/actions/roles";
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";

import italianCorporateCreateTranslations from "../../translations/corporate/create/it.corporate.create.json";
import englishCorporateCreateTranslations from "../../translations/corporate/create/en.corporate.create.json";
import ReactTooltip from "react-tooltip";
import './corporateCreate.css'

class CorporateCreate extends PureComponent {
  state = {
    color: []
  };
  constructor(props) {
    super(props);

    this.props.addTranslationForLanguage(italianCorporateCreateTranslations, "it");
    this.props.addTranslationForLanguage(englishCorporateCreateTranslations, "en");

  }

  componentDidMount() {
    this.props.fetchBanks()
    this.props.corporateHasBankAuthorizerExist(this.props.userIdBank)
  }

  onBackClick = () => {
    this.props.history.goBack();
  }

  submitHandler = (event) => {
    event.preventDefault();
    this.props.saveCorporate(this.props.corporateToCreate)
  }

  render() {
    let errors="";
    errors=this.props.validationError;
    //let noAuthorizer=this.props.noAuthorizer
    let corporateSenderIdError = ""
    let corporateSenderNameError=""
    let logoError=""
    let bankError=""
    let firstReminderNegative=""
    let secondReminderNegative=""
    let validityNegative=""
    let bankRequired=true;
    if(errors !== null && errors !== "" && errors !== undefined){
      if(errors.data.length>0){
        errors.data.map((item) =>{
          if(item.field === 'corporateSenderId')
            corporateSenderIdError=item.defaultMessage;
          if(item.field === 'corporateSenderName')
            corporateSenderNameError=item.defaultMessage;
          if(item.field === 'bank')
            bankError=item.defaultMessage;
          if(item.field === 'logo')
            logoError=item.defaultMessage;
          if(item.field === 'daysToFirstReminder')
            firstReminderNegative=item.defaultMessage;
          if(item.field === 'daysToSecondReminder')
            secondReminderNegative=item.defaultMessage;
          if(item.field === 'timeToExpiry')
            validityNegative=item.defaultMessage;
          return ""
        });
      }
    }
    let role = this.props.role;
    let options = ""
    if(role === Roles.PAYDO_ADMIN || role === Roles.PAYDO_MANAGER){
      options=<FormControl
          className={bankError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
          required={bankRequired}
          as="select"
          onChange={(newValue) => {
        this.onIdBankChange(newValue.target.value);
      }}>
        <option></option>
        {this.props.banks.map((item)=>{
          return <option value={item.bankId}>{item.bankName}</option>
        })}
      </FormControl>
    }else if(role === Roles.BANK_ADMIN || role === Roles.CORPORATE_ADMIN || role === Roles.BANK_CORPORATE_ADMIN){
      let userBankId=this.props.userIdBank;
      this.onIdBankChange(userBankId);
      let bankName=this.props.banks.map((item)=>{
        if(userBankId === item.bankId){
          return item.bankName;
        }
        return ""
      })

      options = <Input
          disabled="disabled"
          className="form-control-alternative"
          value={bankName}
          id="corporateSenderId"
          placeholder="Bank"
          type="text"
      />
    }
    let hasAuthorizerCheck = ''
    if(role === Roles.BANK_ADMIN){
      hasAuthorizerCheck=<input disabled id="email" value={this.props.hasBankAuthorizer} type="checkbox"
                                                   checked={true}   />
    }else{
      hasAuthorizerCheck=<input disabled={this.props.noAuthorizer} id="email" value={this.props.hasBankAuthorizer} type="checkbox"
                                checked={this.props.hasBankAuthorizer} onChange={(event) => this.onCorporateHasBankAuthorizerChange(event.target.checked)}  />
    }



    return (
        <>
          <Header />
          <Container className="mt--5" fluid>
            {/* Table */}
            <Row>
              <div className="col" style={{paddingBottom:"2%"}}>
                <Card className="shadow">
                  <CardHeader className="border-0">
                    <Row>
                      <div className="col">
                        <h3 className="mb-0">
                          <Translate id="corporate.create.title"/>
                        </h3>
                      </div>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    <form onSubmit={this.submitHandler}>
                      <div className="pl-lg-4">
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="corporateSenderId">
                                <Translate id="corporate.create.sender.id"/> *
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                  className={corporateSenderIdError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                  defaultValue="lucky.jesse"
                                  value={this.props.corporateSenderId}
                                  onChange={this.onCorporateSenderIdChange}
                                  id="corporateSenderId"
                                  placeholder={translate("corporate.create.sender.id")}
                                  type="text" />}
                              </Translate>
                              { corporateSenderIdError.length > 0 ? <label style={{color:"red"}}><Translate id={corporateSenderIdError}/></label> : "" }
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="corporateSenderId">
                                <Translate id="corporate.create.sender.name"/> *
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                  className={corporateSenderNameError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                  defaultValue="lucky.jesse"
                                  value={this.props.corporateSenderName} onChange={this.onCorporateSenderNameChange}
                                  id="corporateSenderName"
                                  placeholder={translate("corporate.create.sender.name")}
                                  type="text" />}
                              </Translate>
                              { corporateSenderNameError.length > 0 ? <label style={{color:"red"}}><Translate id={corporateSenderNameError}/></label> : "" }
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="corporateSenderId">
                                <Translate id="corporate.create.bank"/>
                              </label>
                              <option></option>
                              {options}
                              { bankError.length > 0 ? <label style={{color:"red"}}><Translate id={bankError}/></label> : "" }
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="corporateSenderId">
                                <Translate id="corporate.create.logo"/> *
                              </label>
                              <Translate>
                                {({ translate }) =>
                                    <Input
                                      className={logoError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                      onChange={this.onCorporateLogoChange}
                                      id="files"
                                      placeholder={translate("corporate.create.logo")}
                                      type="file" />}
                              </Translate>
                              <span>
                                <small>
                                  <Translate id="corporate.create.logo.size" />
                                </small>
                              </span>
                              { logoError.length > 0 ? <label style={{color:"red"}}><Translate id={logoError}/></label> : "" }
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Row>
                              <Col>
                                <label className="form-control-label" htmlFor="files">
                                  <Translate id="corporate.edit.primary.color"/>
                                </label>
                                <div>
                                  <label>
                                    <div className="result" style={{backgroundColor: this.state.color}}></div>
                                    <input type="color" id="color-picker" ref="color-value"
                                           onChange={this.onCorporateImagePrimaryColorChange.bind(this)}
                                           value={this.props.primaryColor}
                                    />
                                    <span className="select"></span>
                                  </label>
                                </div>
                              </Col>
                              <Col>
                                <FormGroup>
                                  <label className="form-control-label" htmlFor="files">
                                    <Translate id="corporate.create.hasAuthorizer"/>
                                  </label>
                                  <br></br>



                                  {hasAuthorizerCheck}
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <FormGroup>
                                  <label className="form-control-label" htmlFor="files">
                                    <Translate id="corporate.create.autoaccept"/>
                                  </label>
                                  <i className="fa fa-info-circle" aria-hidden="true" data-tip data-for="autoacceptTip">
                                  </i>
                                  <ReactTooltip id="autoacceptTip" place="right" effect="solid" multiline={true} className="tooltip">
                                    <Translate id="corporate.create.autoaccept.tip"/>
                                  </ReactTooltip>
                                  <br></br>
                                  <input id="email" value={this.props.corporateAutoAccept} type="checkbox"
                                         checked={this.props.corporateAutoAccept} onChange={(event) => this.onCorporateAutoAcceptChange(event.target.checked)}  />
                                </FormGroup>
                              </Col>
                              <Col>
                                <FormGroup>
                                  <label className="form-control-label" htmlFor="files">
                                    <Translate id="corporate.create.whatsapp"/>
                                  </label>
                                  <br></br>
                                  <input id="whatsapp" value={this.props.corporateWhatsapp} type="checkbox"
                                         checked={this.props.corporateWhatsapp} onChange={(event) => this.onCorporateWhatsappChange(event.target.checked)}  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <FormGroup>
                                  <label className="form-control-label" htmlFor="daysToFirstReminder">
                                    <Translate id="corporate.create.days.to.firstreminder"/> *
                                  </label>

                                  <Translate>
                                    {({ translate }) =>
                                        <Input
                                            className={'form-control-alternative' }
                                            defaultValue="10"
                                            value={this.props.corporateDaysToFirstReminder} onChange={this.onCorporateDaysToFirstReminderChange}
                                            id="daysToFirstReminder"
                                            placeholder={translate("corporate.create.days.to.firstreminder")}
                                            type="number" />
                                    }
                                  </Translate>
                                  { firstReminderNegative.length > 0 ? <label style={{color:"red"}}><Translate id={firstReminderNegative}/></label> : "" }
                                </FormGroup>
                              </Col>
                              <Col>
                                <FormGroup>
                                  <label className="form-control-label" htmlFor="daysToSecondReminder">
                                    <Translate id="corporate.create.days.to.secondreminder"/> *
                                  </label>

                                  <Translate>
                                    {({ translate }) =>
                                        <Input
                                            className={'form-control-alternative' }
                                            defaultValue="2"
                                            value={this.props.corporateDaysToSecondReminder} onChange={this.onCorporateDaysToSecondReminderChange}
                                            id="daysToSecondReminder"
                                            placeholder={translate("corporate.create.days.to.secondreminder")}
                                            type="number" />
                                    }
                                  </Translate>
                                  { secondReminderNegative.length > 0 ? <label style={{color:"red"}}><Translate id={secondReminderNegative}/></label> : "" }
                                </FormGroup>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <FormGroup>
                              <label className="form-control-label" htmlFor="corporateTimeToExpiry">
                                <Translate id="corporate.create.days.to.expiry"/> *
                              </label>

                              <Translate>
                                {({ translate }) =>
                                    <Input
                                        className={'form-control-alternative' }
                                        defaultValue="lucky.jesse"
                                        value={this.props.corporateTimeToExpiry} onChange={this.onCorporateTimeToExpiryChange}
                                        id="corporateTimeToExpiry"
                                        placeholder={translate("corporate.create.days.to.expiry")}
                                        type="number" />
                                }
                              </Translate>
                              { validityNegative.length > 0 ? <label style={{color:"red"}}><Translate id={validityNegative}/></label> : "" }
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col align="left">
                            <Button onClick={this.onBackClick} variant="contained">
                              <i className="fas fa-arrow-left text-primary" />
                            </Button>
                          </Col>
                          <Col align="right">
                            <Button  type="submit" className="btn-success" variant="contained" >
                              <Translate id="corporate.create.save.button"/>
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </form>
                  </CardBody>
                </Card>
              </div>
            </Row>
          </Container>
        </>
    );
  }

  onCorporateSenderIdChange = (event) => {
    let corporateSenderId = event.target.value
    this.props.corporateSenderIdChange(corporateSenderId)
  }

  onCorporateTimeToExpiryChange = (event) => {
    let timeToExpiry = event.target.value
    this.props.corporateTimeToExpiryChange(timeToExpiry)
  }

  onCorporateAutoAcceptChange(autoAccept){
    if(autoAccept ===true){
      this.props.corporateAutoAcceptChange(true)
    }else if(autoAccept ===false){
      this.props.corporateAutoAcceptChange(false)
    }
    // this.props.getGeneralReport(this.props.generalReport)
  }
  onCorporateWhatsappChange(whatsapp){
    if(whatsapp ===true){
      this.props.corporateWhatsappChange(true)
    }else if(whatsapp ===false){
      this.props.corporateWhatsappChange(false)
    }
    // this.props.getGeneralReport(this.props.generalReport)
  }


  onCorporateHasBankAuthorizerChange(hasBank){
    if(hasBank ===true){

      this.props.corporateHasBankAuthorizerChange(true)
    }else if(hasBank ===false){

      this.props.corporateHasBankAuthorizerChange(false)
    }
    // this.props.getGeneralReport(this.props.generalReport)
  }

  onCorporateSenderNameChange = (event) => {
    let corporateSenderName = event.target.value
    this.props.corporateSenderNameChange(corporateSenderName)
  }

  onCorporateTimeToExpiryChange = (event) => {
    let timeToExpiry = event.target.value
    this.props.corporateTimeToExpiryChange(timeToExpiry)
  }
  onCorporateDaysToFirstReminderChange = (event) => {
    let daysToSecondReminder = event.target.value
    this.props.corporateDaysToFirstReminderChange(daysToSecondReminder)
  }

  onCorporateDaysToSecondReminderChange = (event) => {
    let daysToFirstReminder = event.target.value
    this.props.corporateDaysToSecondReminderChange(daysToFirstReminder)
  }


  onIdBankChange = (bank) => {
    if(bank !== '')
      this.props.idBankChange(bank)
  }

  onEnabledChange = (event) => {
    let enabled = event.target.value === "true" ? true : false
    this.props.enabledChange(enabled)
  }

  onCorporateLogoChange = async (event) => {
    let image = event.target.files[0]
    event.preventDefault();
    let toBase64 = file => new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
    this.props.corporateLogoChange(await toBase64(image))
  }

  onCorporateImagePrimaryColorChange=(value)=>{
    var tValue = value.target.value;
    this.props.corporatePrimaryColorChangeRequest(tValue)
  }
  onCorporateImageSecondaryColorChange=(value)=>{
    var tValue = value.target.value;
    this.props.corporateSecondaryColorChangeRequest(tValue)
  }
}

const mapStateToProps = state => {
  return {
    corporateToCreate: state.corporateCreate.corporateToCreate,
    idBank: state.corporateCreate.corporateToCreate.bank,
    corporateSenderId: state.corporateCreate.corporateToCreate.corporateSenderId,
    corporateAutoAccept: state.corporateCreate.corporateToCreate.autoAccept,
    corporateDaysToFirstReminder: state.corporateCreate.corporateToCreate.daysToFirstReminder,
    corporateDaysToSecondReminder: state.corporateCreate.corporateToCreate.daysToSecondReminder,
    corporateWhatsapp: state.corporateCreate.corporateToCreate.whatsapp,
    corporateTimeToExpiry: state.corporateCreate.corporateToCreate.timeToExpiry,
    corporateSenderName: state.corporateCreate.corporateToCreate.corporateSenderName,
    enabled: state.corporateCreate.corporateToCreate.enabled === true ? "true" : "false",
    corporateLogo: state.corporateCreate.corporateToCreate.logo,
    banks: state.bank.banks,
    role:state.authentication.authenticatedUser.role,
    userIdBank:state.authentication.authenticatedUser.idBank,
    validationError:state.corporateCreate.error,
    noAuthorizer:state.corporateCreate.noAuthorizer,
    primaryColor:state.corporateCreate.corporateToCreate.primaryColor,
    secondaryColor:state.corporateCreate.corporateToCreate.secondaryColor,
    hasBankAuthorizer:state.corporateCreate.corporateToCreate.hasBankAuthorizer,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    saveCorporate: (corporate) => dispatch({ type: actions.SAVE_CORPORATE_CREATE_REQUEST, value: corporate }),
    idBankChange: (idBank) => dispatch({ type: actions.CREATE_CORPORATE_ID_BANK_FIELD_CHANGE_REQUEST, value: idBank }),
    corporateSenderNameChange: (corporateSenderName) => dispatch({ type: actions.CREATE_CORPORATE_CORPORATE_SENDER_NAME_FIELD_CHANGE_REQUEST, value: corporateSenderName }),
    corporateSenderIdChange: (corporateSenderId) => dispatch({ type: actions.CREATE_CORPORATE_CORPORATE_SENDER_ID_FIELD_CHANGE_REQUEST, value: corporateSenderId }),
    enabledChange: (enabled) => dispatch({ type: actions.CREATE_CORPORATE_ENABLED_FILED_CHANGE_REQUEST, value: enabled }),
    corporateLogoChange: (corporateLogo) => dispatch({ type: actions.CREATE_CORPORATE_CORPORATE_LOGO_FILED_CHANGE_REQUEST, value: corporateLogo }),
    fetchBanks: () => dispatch({ type: actions.FETCH_BANKS_REQUEST }),
    corporatePrimaryColorChangeRequest:(color)=>dispatch({type:actions.CREATE_CORPORATE_PRIMARY_COLOR_CHANGE_REQUEST,value:color}),
    corporateSecondaryColorChangeRequest:(color)=>dispatch({type:actions.CORPORATE_SECONDARY_COLOR_CHANGE_REQUEST,value:color}),
    corporateAutoAcceptChange: (autoAccept) => dispatch({ type: actions.CREATE_CORPORATE_CORPORATE_AUTOACCEPT_FIELD_CHANGE_REQUEST, value: autoAccept }),
    corporateDaysToFirstReminderChange: (firstReminder) => dispatch({ type: actions.CREATE_CORPORATE_CORPORATE_DAYS_TO_FIRST_REMINDER_FIELD_CHANGE_REQUEST, value: firstReminder }),
    corporateDaysToSecondReminderChange: (secondReminder) => dispatch({ type: actions.CREATE_CORPORATE_CORPORATE_DAYS_TO_SECOND_REMINDER_FIELD_CHANGE_REQUEST, value: secondReminder }),
    corporateWhatsappChange: (whatsapp) => dispatch({ type: actions.CREATE_CORPORATE_CORPORATE_WHATSAPP_FIELD_CHANGE_REQUEST, value: whatsapp }),
    corporateHasBankAuthorizerExist: (bankId) => dispatch({ type: actions.CREATE_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_EXISTS_REQUEST, value: bankId }),
    corporateHasBankAuthorizerChange: (hasBank) => dispatch({ type: actions.CREATE_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_CHANGE_REQUEST, value: hasBank }),
    corporateTimeToExpiryChange: (timeToExpiry) => dispatch({ type: actions.CREATE_CORPORATE_CORPORATE_TIME_TO_EXPIRE_FIELD_CHANGE_REQUEST, value: timeToExpiry }),

  }
}

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(CorporateCreate));